module.exports = __webpack_public_path__ + "static/media/casabela-5.82f37812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/casabela-5.png
// module id = 165
// module chunks = 1